export var STREAM__DELETE_ITEMS = 'STREAM__DELETE_ITEMS';
export var STREAM__MOVE_ITEM = 'STREAM__MOVE_ITEM';
export var STREAM__REPLACE_ITEM = 'STREAM__REPLACE_ITEM';
export var STREAM__FETCH_FAILURE = 'STREAM__FETCH_FAILURE';
export var STREAM__DELETE_STREAM = 'STREAM__DELETE_STREAM';
export var STREAM__SET_PARAM = 'STREAM__SET_PARAM';
export var STREAM__INSERT_ITEMS = 'STREAM__INSERT_ITEMS';
export var deleteItem = function (_a) {
    var streamId = _a.streamId, item = _a.item;
    return ({
        type: STREAM__DELETE_ITEMS,
        streamId: streamId,
        items: [item],
    });
};
export var deleteItems = function (_a) {
    var streamId = _a.streamId, items = _a.items;
    return ({
        type: STREAM__DELETE_ITEMS,
        streamId: streamId,
        items: items,
    });
};
export var moveItem = function (_a) {
    var streamId = _a.streamId, item = _a.item, position = _a.position;
    return ({
        type: STREAM__MOVE_ITEM,
        streamId: streamId,
        item: item,
        position: position,
    });
};
export var fetchFailure = function (_a) {
    var streamId = _a.streamId, errorMsg = _a.errorMsg;
    return ({
        type: STREAM__FETCH_FAILURE,
        streamId: streamId,
        errorMsg: errorMsg,
    });
};
export var deleteStream = function (streamId) { return ({
    type: STREAM__DELETE_STREAM,
    streamId: streamId,
}); };
export var replaceItem = function (_a) {
    var streamId = _a.streamId, newItem = _a.newItem, predicate = _a.predicate;
    return ({
        type: STREAM__REPLACE_ITEM,
        streamId: streamId,
        newItem: newItem,
        predicate: predicate,
    });
};
export var insertItemsAtOffsets = function (_a) {
    var streamId = _a.streamId, newItems = _a.newItems, deduplicate = _a.deduplicate;
    return ({
        type: STREAM__INSERT_ITEMS,
        streamId: streamId,
        newItems: newItems,
        deduplicate: deduplicate,
    });
};
export var setParam = function (_a) {
    var streamId = _a.streamId, paramType = _a.paramType, paramValue = _a.paramValue;
    return ({
        type: STREAM__SET_PARAM,
        streamId: streamId,
        paramType: paramType,
        paramValue: paramValue,
    });
};
//# sourceMappingURL=actions.js.map